import React, { useMemo, useState } from 'react';

import './index.scss';
import { useUserStore } from '../../../../stores';
import { t } from '../../../../locales';
import OpenVip from '../OpenVip';
import { Skeleton } from 'antd';
type Props = {

}
const Vip = (props: Props) => {
  const { currentUser } = useUserStore();
  const [showSyncModal, setShowSyncModal] = useState(false);
  const remainingText = (minutes: number) => t('vip.minutesLeft', { count: minutes });

  const vipDom = useMemo(() => {
    if (!currentUser) {
      return <Skeleton.Button active className='vip-skeleton' style={{ width: '244px', height: '94px' }} />
    }

    // 如果 snIsFree 为 true，不显示任何会员卡片
    if (currentUser?.snIsFree) {
      return null
    }

    // 判断是否未激活：userEquipmentList 为空或 null，且 member 为 null
    const isNotActivated = (!currentUser?.userEquipmentList || currentUser?.userEquipmentList?.length === 0) && !currentUser?.member;
    if (isNotActivated) {
      // 未激活会员（未绑定设备）
      return (
        <div className='member-vip' onClick={() => setShowSyncModal(true)}>
          <p className='member-vip-title'>{t('vip.lock')}</p>
          <p className='member-vip-desc'>{t('vip.lockDesc')}</p>
          <div className='member-vip-btn'>{t('vip.lockNowBtnText')}</div>
        </div>
      )
    }
    if (!currentUser?.member) {
      return null
    }
    if (currentUser?.member?.planCode === 'pro') {
      // pro 会员
      const percentage = currentUser?.member?.minutes?.planTotal > 0
        ? Math.min((currentUser?.member?.minutes?.remaining / currentUser?.member?.minutes?.planTotal) * 100, 100)
        : 0;
      return (
        <div className='member-vip pro-vip'>
          <p className='member-vip-title'>{t('vip.proVipName')}</p>
          <p className='member-vip-remaining'>
            {remainingText(currentUser?.member?.minutes?.remaining)}
          </p>
          <div className='member-vip-times'>
            <div className='member-vip-times-left' style={{ width: `${percentage}%` }}></div>
          </div>
          <p className='member-vip-reset-date'>
            {t('vip.timeReset')}： {currentUser?.member?.minutes.nextResetDate}
          </p>
        </div>
      )
    }
    if (currentUser?.member?.planCode === 'starter') {
      // starter 会员
      const percentage = currentUser?.member?.minutes?.planTotal > 0
        ? Math.min((currentUser?.member?.minutes?.remaining / currentUser?.member?.minutes?.planTotal) * 100, 100)
        : 0;
      return (
        <div className='member-vip star-vip'>
          <p className='member-vip-title'>{t('vip.starVipName')}</p>
          <p className='member-vip-remaining'>
            {remainingText(currentUser?.member?.minutes?.remaining)}
          </p>
          <div className='member-vip-times'>
            <div className='member-vip-times-left' style={{ width: `${percentage}%` }}></div>
          </div>
          <p className='member-vip-reset-date'>
            {t('vip.timeReset')}： {currentUser?.member?.minutes.nextResetDate}
          </p>
        </div>
      )
    }
    if (currentUser?.member?.planCode === 'unlimited') {
      // unlimited 会员
      return (
        <div className='member-vip unlimited-vip'>
          <p className='member-vip-title'>{t('vip.unlimitedVipName')}</p>
          <p className='member-vip-remaining'>
            {remainingText(currentUser?.member?.minutes?.remaining)}
          </p>
          <div className='member-vip-times'>
            <div className='member-vip-times-left' style={{ width: '100%' }}></div>
          </div>
        </div>
      )
    }
    return null
  }, [currentUser])

  const timePkg = useMemo(() => {
    // 如果 snIsFree 为 true，不显示转写时长包
    if (currentUser?.snIsFree) {
      return null
    }

    // 检查是否有转写时长包
    if (!currentUser?.transcriptionPackage) {
      return null
    }
    const pkg = currentUser.transcriptionPackage
    const remainingMinutes = pkg.remainingMinutes || 0
    const totalMinutes = pkg.totalMinutes || 0
    const expireDate = pkg.expireDate || ''
    const status = pkg.status || ''

    // 检查是否已过期（使用 status 参数）
    if (status === 'expired') {
      return null
    }

    // 如果剩余时长为0但未过期，依然显示，标记为已用完
    const isUsedUp = remainingMinutes === 0
    const percentage = totalMinutes > 0 ? Math.min((remainingMinutes / totalMinutes) * 100, 100) : 0

    return (
      <div className={`member-vip time-pkg ${isUsedUp ? 'time-pkg-used-up' : ''}`} style={{ marginTop: '12px' }}>
        <p className='member-vip-title'>{t('vip.transTimeName')}</p>
        <p className='member-vip-remaining'>
          {isUsedUp
            ? t('vip.usedUp')
            : remainingText(remainingMinutes)
          }
        </p>
        <div className='member-vip-times'>
          <div className='member-vip-times-left' style={{ width: `${percentage}%` }}></div>
        </div>
        <p className='member-vip-reset-date'>
          {t('vip.timeEnd')}： {expireDate}
        </p>
      </div>
    )
  }, [currentUser])

  return (
    <>
      {vipDom}
      {timePkg}
      <OpenVip showModal={showSyncModal} setShowSyncModal={setShowSyncModal} />
    </>
  )

}

export default Vip;
